import { Component, Input, OnInit,Output,EventEmitter } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';
import { CountriesInt, SelectModalData, phoneContactInt } from '@app/interfaces';
import { LocalDataService } from '@app/services/local-data.service';
import { MessagesService } from '@app/services/messages.service';
import { TranslateService } from '@ngx-translate/core';
import { AmKeyboardService } from '../am-keyboard/am-keyboard.service';

/**
  Componente que permite ingresar y validar un número de teléfono con selección de país.
  Este componente implementa `ControlValueAccessor` para integrarse con formularios reactivos
  y permite seleccionar un país desde un modal para completar el código de área del teléfono.
  También emite la información del teléfono y el país seleccionado.
**/
@Component({
    selector: 'app-phone-input',
    templateUrl: './phone-input.component.html',
    styleUrls: ['./phone-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: PhoneInputComponent
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: PhoneInputComponent
        }
    ],
    standalone: false
})
export class PhoneInputComponent implements OnInit, ControlValueAccessor {
  @Output() dataPhoneInformation = new EventEmitter<any>();
  @Input() className = '';
  @Input() formControl = '';
  @Input() inputFullSize = false;
  @Input() textControl;
  @Input() errorPattern = '';
  @Input() errorRequired = '';
  @Input() formGroup: FormGroup;
  @Input() nameInput= '';
  @Input() label= '';
  @Input() maxlength;
  @Input() iconDelete = true;
  @Input() placeholder = '';
  @Input() typeInput = 'text';
  @Input() classNameMessage = 'AmInputForm-formCorrect';
  @Input() classNameIcon = 'AmInputForm-formCorrect';
  @Input() nameList;
  @Input() styleInput= '';
  val:string;

  formPhone = new FormGroup({
    phone: new FormControl()
  });

  countrySelected = '';
  countryCode = '';
  phone = '';

  currentLang = '';
  countries: CountriesInt[] = [];



  constructor(
    private messageServ: MessagesService,
    private localServ: LocalDataService,
    private _keyboardService: AmKeyboardService,
    localeServ: TranslateService )
  {
    this.currentLang = localeServ.currentLang.replace("-", "_");
  }

  writeValue(value: any): void {
    this.value = value;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
  }

  ngOnInit(): void {
    this.control.valueChanges.subscribe({
      next: (val) => this.inputPhone = val
    });

    const { country3, countryCode,country } = this.localServ.countries.find(country => country.country3 === 'MEX');

    this.countrySelected = country3;
    this.countryCode = `+${countryCode}`;
    this.inputPhone = '';
    this.inputDataPhone = {country,country3,countryCode};
  }
 /**
    Abre un modal para seleccionar un país y actualiza el código de área y el país seleccionado.
    @return void
  **/
  showModal() {
    const backup = this.countries[0] || null ;
    this.countries = [];

    const options: SelectModalData = {
      title: 'modalSelect.residence.title',
      subtitle: 'modalSelect.residence.subtitle',
      notice: 'modalSelect.residence.notice',
      list: this.localServ.countries
    };

    this.messageServ.showListSelect(options)
      .then(res => {
        this.countrySelected = res.country3;
        this.countryCode = `+${res.countryCode}`;
        this.inputDataPhone =res;
        this.inputPhone = this.phone;
      })
      .catch(() => {
        if (backup) {
          this.countries.push(backup);
        }
      })
      .finally(() => {
        this._keyboardService.hide();
      })
  }

  validate(control: AbstractControl): ValidationErrors | null
  {
    return null;
  }

  set inputPhone(val: string) {
    this.phone =  val;
  }

  set inputDataPhone(val: phoneContactInt) {
    this.dataPhoneInformation.emit(val);
  }


  get control() {
    return this.formPhone.get('phone');
  }

  onChange: any = (val) => {};
  onTouched: any = (val) => {};
  /**
    Establece el valor del input y notifica los cambios.
    @param {string} val - Valor del input.
    @return void
  **/
  set value(val){
    this.val = val
    this.onChange(val)
    if(val){
      this.onTouched(val)
    }
  }

  onDelete(){
    this.value = ''
  }
}
